// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".article .author-box .info .loverly-text{font-size:1rem;line-height:1.5rem}.article .author-box .info .mb-8{display:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
